import { render, staticRenderFns } from "./foodList.vue?vue&type=template&id=e671d1fc&scoped=true"
import script from "./foodList.vue?vue&type=script&lang=js"
export * from "./foodList.vue?vue&type=script&lang=js"
import style0 from "./foodList.vue?vue&type=style&index=0&id=e671d1fc&prod&lang=scss&scoped=true"
import style1 from "./foodList.vue?vue&type=style&index=1&id=e671d1fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e671d1fc",
  null
  
)

export default component.exports